module.exports = __webpack_public_path__ + "img/C8C8C8_3F3F3F_787878_5C5C5C-256px.756bfd86.png";